module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Crissier-01e8134671a81d9038445f59672e054b.svg";